var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.735 15.66C4.11 14.457 2.841 13.03 2.107 12c.734-1.03 2.003-2.456 3.628-3.66C7.514 7.02 9.675 6 12 6s4.486 1.021 6.265 2.34c1.625 1.204 2.894 2.63 3.628 3.66-.734 1.03-2.003 2.456-3.628 3.66C16.486 16.98 14.325 18 12 18s-4.486-1.021-6.265-2.34M12 5C9.384 5 7.016 6.145 5.14 7.536c-1.878 1.391-3.306 3.06-4.056 4.187a.5.5 0 0 0 0 .554c.75 1.127 2.178 2.796 4.056 4.187C7.016 17.854 9.384 19 12 19s4.984-1.145 6.86-2.536c1.878-1.391 3.307-3.06 4.056-4.187a.5.5 0 0 0 0-.554c-.75-1.127-2.178-2.796-4.056-4.187C16.984 6.146 14.616 5 12 5m3 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0m1 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
    clipRule: "evenodd"
  })));
});
const SvgVisibilityOn = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisibilityOn);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjczNTIxIDE1LjY2MDhDNC4xMDk3IDE0LjQ1NjEgMi44NDA4NyAxMy4wMyAyLjEwNzIgMTJDMi44NDA4NyAxMC45NyA0LjEwOTcgOS41NDM5IDUuNzM1MjEgOC4zMzkyMUM3LjUxMzYgNy4wMjEyMiA5LjY3NTI1IDYgMTIgNkMxNC4zMjQ3IDYgMTYuNDg2NCA3LjAyMTIyIDE4LjI2NDggOC4zMzkyMUMxOS44OTAzIDkuNTQzOSAyMS4xNTkxIDEwLjk3IDIxLjg5MjggMTJDMjEuMTU5MSAxMy4wMyAxOS44OTAzIDE0LjQ1NjEgMTguMjY0OCAxNS42NjA4QzE2LjQ4NjQgMTYuOTc4OCAxNC4zMjQ3IDE4IDEyIDE4QzkuNjc1MjUgMTggNy41MTM2IDE2Ljk3ODggNS43MzUyMSAxNS42NjA4Wk0xMiA1QzkuMzgzNTcgNSA3LjAxNTgxIDYuMTQ1NDUgNS4xMzk3OSA3LjUzNTc5QzMuMjYyMjUgOC45MjcyNiAxLjgzMzUxIDEwLjU5NTggMS4wODM2OSAxMS43MjMxQzAuOTcyMTA1IDExLjg5MDggMC45NzIxMDUgMTIuMTA5MiAxLjA4MzY5IDEyLjI3NjlDMS44MzM1MSAxMy40MDQyIDMuMjYyMjUgMTUuMDcyNyA1LjEzOTc5IDE2LjQ2NDJDNy4wMTU4MSAxNy44NTQ2IDkuMzgzNTcgMTkgMTIgMTlDMTQuNjE2NCAxOSAxNi45ODQyIDE3Ljg1NDYgMTguODYwMiAxNi40NjQyQzIwLjczNzcgMTUuMDcyNyAyMi4xNjY1IDEzLjQwNDIgMjIuOTE2MyAxMi4yNzY5QzIzLjAyNzkgMTIuMTA5MiAyMy4wMjc5IDExLjg5MDggMjIuOTE2MyAxMS43MjMxQzIyLjE2NjUgMTAuNTk1OCAyMC43Mzc3IDguOTI3MjYgMTguODYwMiA3LjUzNTc5QzE2Ljk4NDIgNi4xNDU0NSAxNC42MTY0IDUgMTIgNVpNMTUgMTJDMTUgMTMuNjU2OSAxMy42NTY5IDE1IDEyIDE1QzEwLjM0MzEgMTUgOSAxMy42NTY5IDkgMTJDOSAxMC4zNDMxIDEwLjM0MzEgOSAxMiA5QzEzLjY1NjkgOSAxNSAxMC4zNDMxIDE1IDEyWk0xNiAxMkMxNiAxNC4yMDkxIDE0LjIwOTEgMTYgMTIgMTZDOS43OTA4NiAxNiA4IDE0LjIwOTEgOCAxMkM4IDkuNzkwODYgOS43OTA4NiA4IDEyIDhDMTQuMjA5MSA4IDE2IDkuNzkwODYgMTYgMTJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";